"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var react_responsive_carousel_1 = require("react-responsive-carousel");
require("react-responsive-carousel/lib/styles/carousel.min.css");
var functions_1 = require("../interfaces/functions");
var ProductDetails = function (_a) {
    var product = _a.product, onClose = _a.onClose;
    return (react_1.default.createElement(material_1.Dialog, { open: true, onClose: onClose, maxWidth: "lg", fullWidth: true },
        react_1.default.createElement(material_1.DialogTitle, { sx: { fontWeight: "bold" } }, product.ProductName),
        react_1.default.createElement(material_1.DialogContent, null,
            react_1.default.createElement("div", { style: { display: "flex", alignItems: "center" } },
                product.pro_images.length > 0 && (react_1.default.createElement("div", { style: { flex: "0 0 40%", marginRight: "2rem" } },
                    react_1.default.createElement(react_responsive_carousel_1.Carousel, { showArrows: false, showThumbs: false }, product.pro_images.map(function (image, index) { return (react_1.default.createElement("div", { key: index },
                        react_1.default.createElement("img", { src: image.ImagePath, alt: product.ProductName, style: { maxWidth: "100%", maxHeight: "80vh" } }))); })))),
                react_1.default.createElement("div", { style: { flex: "1" } },
                    react_1.default.createElement(material_1.Typography, { variant: "body2", color: "text.secondary" }, product.ProductDesc),
                    react_1.default.createElement(material_1.Typography, { variant: "h6", sx: { fontWeight: "bold", textAlign: "left", marginTop: "1rem" } },
                        "$",
                        product.ProductPrice.toLocaleString())))),
        react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(material_1.Button, { onClick: onClose, color: "primary" }, "Close"),
            react_1.default.createElement(material_1.Button, { onClick: function () { return (0, functions_1.AddToCart)(product.ProductID); }, color: "primary", variant: "contained" }, "Add to Cart"))));
};
exports.default = ProductDetails;
